export default function calculateFileSizeInBytes(base64String) {
  // Remove the header if it exists
  const base64WithoutHeader = base64String.split(",")[1] || base64String;

  // Get the length of the string without padding
  let stringLength = base64WithoutHeader.length;

  // Account for padding characters
  let paddingCharCount = 0;
  if (base64WithoutHeader.endsWith("==")) {
    paddingCharCount = 2;
    stringLength -= 2;
  } else if (base64WithoutHeader.endsWith("=")) {
    paddingCharCount = 1;
    stringLength -= 1;
  }

  // Calculate the number of bytes
  // Every 4 base64 characters represent 3 bytes of data
  const sizeInBytes = (stringLength * 3) / 4 + paddingCharCount;

  return Math.floor(sizeInBytes); // Ensure an integer result
}
